import { render, staticRenderFns } from "./WidgetMockup.vue?vue&type=template&id=b065fecc&scoped=true"
import script from "./WidgetMockup.vue?vue&type=script&lang=js"
export * from "./WidgetMockup.vue?vue&type=script&lang=js"
import style0 from "./WidgetMockup.vue?vue&type=style&index=0&id=b065fecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b065fecc",
  null
  
)

export default component.exports